import axios from 'axios'
import { usecaseApiUrl } from '../config/config'
import { processUsecaseFromForm } from './preprocessing.service'
import { PAGE_SIZE } from '../config/constant'
import { Area, Usecase } from 'src/redux/reducers/types'

// GET ALL USECASES AND FILTER BY QUERY
export async function getMany({ query = '', params = {} }) {
    return axios.get(`${usecaseApiUrl}/usecases`, {
        params: {
            limit: PAGE_SIZE,
            sort: '-createdAt',
            ...params,
            q: query,
        },
    })
}

// GET ALL USECASES
export async function getUsecases() {
    let result = await axios(`${usecaseApiUrl}/usecases`)

    return result
}

// GET USECASE BY ID
export async function getUsecaseById(usecase_id: number) {
    let usecase = undefined
    await axios(`${usecaseApiUrl}/usecase/${usecase_id}`).then(async (result) => {
        if (result.status === 200) {
            usecase = result.data.usecase
            usecase.attributes_json.areas = await getAreasByIds(usecase.attributes_json.areas.map((area: Area) => area.id))
        }
    })

    return usecase
}

export async function getAreasByIds(areaIds: number[]) {
    let result = await axios(`${usecaseApiUrl}/areas?ids=${areaIds.join(',')}`)

    return result.data.data
}

// GET ENVIRONMENT CONFIGURATION BY ID
export async function getEnvironmentConfig(id: number) {
    let result = await axios(`${usecaseApiUrl}/environment/config/${id}`)

    return result
}

// GET MAPBOX TOKEN

export async function getMapboxAccessToken() {
    let result = await axios(`${usecaseApiUrl}/mapbox_access_token`)

    return result
}

// POST A USECASE JSON FOR CREATION
export async function postUsecase(usecase_data: Usecase) {
    let data

    let status = {
        message: '',
        success: false,
        uploaded: false,
    }

    const usecase = await processUsecaseFromForm(usecase_data)

    if (usecase.error) {
        status.message = usecase.data as string
        status.success = false
        status.uploaded = false

        return [status, data]
    }

    try {
        const result = await axios.post(`${usecaseApiUrl}/usecase/`, JSON.stringify(usecase.data), {
            headers: {
                'Content-Type': 'application/json',
            },
        })
        if (result && result.data && result.data.content) {
            data = JSON.parse(result.data.content)
        }

        status.message = 'Use case was uploaded properly'
        status.success = true
        status.uploaded = true
    } catch (error) {
        status.message = (error as any).response?.data?.message
        status.success = false
        status.uploaded = true
    }

    return [status, data]
}

// POST A USECASE JSON FILE FOR CREATION
export async function importUsecase(inputFile: any) {
    let status = {
        message: '',
        success: false,
        uploaded: false,
    }

    const formData = new FormData()
    formData.append('file', inputFile)

    let data

    try {
        const result = await axios.post(`${usecaseApiUrl}/usecase/verification`, formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        })
        if (result && result.data && result.data.content) {
            data = JSON.parse(result.data.content)
        }

        status.message = 'Use case was uploaded properly'
        status.success = true
        status.uploaded = true
    } catch (error) {
        status.message = (error as any).response?.data?.message
        status.success = false
        status.uploaded = true
    }

    return [status, data]
}
